import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';
import { prepareFilters } from '../../../../components/Filters/request';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      ...item.regular_user,
      key: item.regular_user.uuid,
      creator: {
        uuid: item.regular_user.uuid,
        avatar_url: item.regular_user.avatar_url,
        avatar_params: item.regular_user.avatar_params,
        name: item.regular_user.name,
        social_accounts: item.regular_user.social_accounts,
        connection_id: item.id
      },
      links: item.lifetime_links,
      clicks: item.lifetime_clicks,
      sales: item.lifetime_gmv,
      last_link_shared: item.last_link_shared,
      campaigns: item.top_campaigns,
      groups: item.top_groups,
      connection_id: item.id,
      select: { id: item.regular_user.uuid, value: false },
      operations: item.regular_user
    };
    dataTable.push(el);
  });

  return dataTable;
};

function buildRequestData({ curr_page, filters, searchQ, exclude }) {
  const sort = prepareFilters(filters).sort;
  return {
    page: curr_page,
    ...(searchQ && { q: searchQ }),
    ...(sort && { sort: sort[0] }),
    ...(exclude && { exclude_uuids: exclude })
  };
}

function* fetchConnectedScrollPage({ signal, filters, searchQ, exclude, curr_page }) {
  const { data } = yield call(fetch, {
    api: api.unmasking.connections.search,
    data: buildRequestData({ curr_page, filters, searchQ, exclude }),
    signal
  });

  return {
    dataTable: prepareDataTable(data.results),
    message: data.message,
    count: data.count,
    next: data.next,
    previous: data.previous ?? null
  };
}

function* getMyCreatorsConnectedScroll({ payload: { signal, filters, searchQ, exclude, curr_page } }) {
  try {
    const result = yield call(fetchConnectedScrollPage, { signal, filters, searchQ, exclude, curr_page });

    yield put(actions.getMyCreatorsConnectedScrollDone({
      ...result,
      curr_page
    }));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getMyCreatorsConnectedScrollFailed,
      endpoint: api.unmasking.connections.search.url
    });
  }
}

function* refreshMyCreatorsConnectedScroll({ payload: { signal, filters, searchQ, exclude, upto_page } }) {
  try {
    const targetPage = Math.max(1, parseInt(upto_page, 10) || 1);

    let all = [];
    let lastMeta = { count: 0, next: null, previous: null, message: null };
    let lastFetchedPage = 1;

    for (let p = 1; p <= targetPage; p++) {
      const pageRes = yield call(fetchConnectedScrollPage, {
        signal,
        filters,
        searchQ,
        exclude,
        curr_page: p
      });

      all = all.concat(pageRes.dataTable);
      lastMeta = pageRes;
      lastFetchedPage = p;

      if (!pageRes.next) break;
    }

    yield put(actions.refreshMyCreatorsConnectedScrollDone({
      dataTable: all,
      count: lastMeta.count,
      next: lastMeta.next,
      previous: lastMeta.previous,
      message: lastMeta.message,
      curr_page: lastFetchedPage
    }));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.refreshMyCreatorsConnectedScrollFailed,
      endpoint: api.unmasking.connections.search.url
    });
  }
}

export const getMyCreatorsConnectedScrollSaga = takeEvery(
  types.GET_MY_CREATORS_CONNECTED_SCROLL_REQUEST,
  getMyCreatorsConnectedScroll
);

export const refreshMyCreatorsConnectedScrollSaga = takeLatest(
  types.REFRESH_MY_CREATORS_CONNECTED_SCROLL_REQUEST,
  refreshMyCreatorsConnectedScroll
);